var map = {
	"./accessible.svg": 235,
	"./air_conditioning.svg": 236,
	"./carpet.svg": 237,
	"./cd_mp3_player.svg": 238,
	"./cd_player.svg": 239,
	"./cloakroom.svg": 240,
	"./coffee_tea.svg": 241,
	"./contactless_entry.svg": 242,
	"./copier.svg": 243,
	"./daylight.svg": 244,
	"./display.svg": 245,
	"./disposable_gloves.svg": 246,
	"./disposable_towels.svg": 247,
	"./distance_markings.svg": 248,
	"./dvd_player.svg": 249,
	"./facilitators_kit.svg": 250,
	"./flip_chart.svg": 251,
	"./frequent_airing.svg": 252,
	"./frequent_cleaning.svg": 253,
	"./hand_sanitizer.svg": 254,
	"./lan_access_extra_charge.svg": 255,
	"./lan_access_free.svg": 256,
	"./landline_phone.svg": 257,
	"./laptop.svg": 258,
	"./lockable.svg": 259,
	"./masks.svg": 260,
	"./masks_KN95_FFP2.svg": 261,
	"./microphone_clip_on.svg": 262,
	"./microphone_wired.svg": 263,
	"./microphone_wireless.svg": 264,
	"./one_way_corridors.svg": 265,
	"./overhead_projector.svg": 266,
	"./pa_system.svg": 267,
	"./pens_paper.svg": 268,
	"./pin_board.svg": 269,
	"./power_sockets.svg": 270,
	"./projector_projection_screen.svg": 271,
	"./room_can_be_darkened.svg": 272,
	"./safety_signage.svg": 273,
	"./separate_entrance_exit.svg": 274,
	"./soft_drinks.svg": 275,
	"./speakers_lectern.svg": 276,
	"./temperature_scan.svg": 277,
	"./video_camera.svg": 278,
	"./video_conferencing_system.svg": 279,
	"./water.svg": 280,
	"./whiteboard.svg": 281,
	"./windows_to_open.svg": 282,
	"./wlan_extra_charge.svg": 283,
	"./wlan_free.svg": 284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;